import { orderCatalogue } from "./catalogue-order";
function fromCatalogue(s) {
    var _a, _b, _c, _d;
    return {
        id: `cat-${s.id}`,
        name: s.name,
        tag: (_a = s.tag) !== null && _a !== void 0 ? _a : "",
        freq: "",
        logoUrl: (_b = s.logoUrl) !== null && _b !== void 0 ? _b : undefined,
        streamUrl: (_c = s.streamUrl) !== null && _c !== void 0 ? _c : undefined,
        metadataId: (_d = s.metadataId) !== null && _d !== void 0 ? _d : undefined,
    };
}
const norm = (name) => name.trim().toLowerCase();
export function withGlobalStations(global, custom, disabledIds = [], order) {
    const off = new Set(Array.isArray(disabledIds) ? disabledIds : []);
    const base = orderCatalogue(Array.isArray(global) ? global : [], order)
        .filter((s) => !off.has(s.id))
        .map(fromCatalogue);
    const taken = new Set(base.map((s) => norm(s.name)));
    const extra = (Array.isArray(custom) ? custom : []).filter((s) => { var _a; return !taken.has(norm((_a = s.name) !== null && _a !== void 0 ? _a : "")); });
    return [...base, ...extra];
}
